{
  "sdk-download-android": "Für Android herunterladen",
  "sdk-connect": "Verbinden",
  "sdk-download-ios": "Für iOS herunterladen",
  "sdk-install": "Installieren",
  "sdk-modal-instruct-1": "1. Binance-App öffnen",
  "sdk-modal-instruct-2": "2. Tippe auf dem Startbildschirm auf {{icon}}",
  "sdk-modal-title": "Mit Binance verknüpfen",
  "sdk-no-app": "Du hast die Binance-App noch nicht?"
}